var React = require('react');

function ProjectsIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"4.75","y":"4.75","width":"14.5","height":"19.5","rx":"1.25","stroke":"#6B3FFC","strokeWidth":"1.5","key":0}),React.createElement("path",{"stroke":"#6B3FFC","d":"M.5 20V1M0 .5h16","key":1})]);
}

ProjectsIcon.defaultProps = {"width":"20","height":"25","fill":"none"};

module.exports = ProjectsIcon;

ProjectsIcon.default = ProjectsIcon;
